// Field internal names must match Alphawhale's HubSpot form exactly, or the v3 API rejects the submission.

export const CONTACT_OBJECT_TYPE_ID = "0-1";

export const FIELD = {
  firstName: "firstname",
  lastName: "lastname",
  email: "email",
  mobile: "mobilephone",
  school: "school",
  serviceId: "service_id",
  brand: "brand",
  zip: "zip",
  firstYear: "first_year_attending_school",
} as const;

export const UTM_FIELDS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"] as const;
export type UtmField = (typeof UTM_FIELDS)[number];

// Must match HubSpot's option list exactly.
export const FIRST_YEAR_OPTIONS = ["2027", "2028", "2029", "2030"] as const;

// Only the three live brands map; any other env sends no brand (an unknown value fails the submission).
export const BRAND_BY_ENVIRONMENT: Record<string, string> = {
  OSH: "OSHClub",
  POSH: "Primary OSHCare",
  HH: "Helping Hands Network",
};

export const getBrandValue = (): string => BRAND_BY_ENVIRONMENT[process.env.GATSBY_SITE_ENVIRONMENT ?? ""] ?? "";

// Fallbacks used when a Storyblok field is left blank (it arrives as "", not undefined).
export const DEFAULT_HEADING = "Register your interest";
export const DEFAULT_SUBMIT_LABEL = "Register";
export const DEFAULT_SUCCESS_MESSAGE = "Thank you for registering your interest";

// Text sent must match text shown.
export const DEFAULT_CONSENT_TO_PROCESS_TEXT =
  "By clicking submit below, you consent to allow Junior Adventures Group to store and process the personal information submitted above to provide you the content requested.";

export const DEFAULT_COMMUNICATIONS_CONSENT_TEXT =
  "I agree to receive other communications from Junior Adventures Group.";

export const DEFAULT_SUBSCRIPTION_TYPE_ID = 1542467189;

export const SUBMIT_ENDPOINT = (portalId: string, formGuid: string) =>
  `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formGuid}`;
